import { z } from 'zod';
import { client, clientWithoutInterceptors } from '../utils/http';

export interface GenerateCodeRequest {
  phoneNumber: string,
  force?: boolean,
}
export interface AuthenticateRequest {
  phoneNumber: string,
  code: string,
}
const AuthenticateResponse = z.object({
  customerId: z.number().optional(),
  riseupAccountId: z.number().optional(),
  memberId: z.string().optional(),
  challenger: z.boolean(),
});
type AuthenticateResponse = z.infer<typeof AuthenticateResponse>;

export async function generateCode({ phoneNumber, force = false }: GenerateCodeRequest): Promise<unknown> {
  const response = await clientWithoutInterceptors.post('/api/no-auth/login/generate-code', { phoneNumber, force });
  return response.data;
}
export async function authenticate({ phoneNumber, code }: AuthenticateRequest): Promise<AuthenticateResponse> {
  const response = await clientWithoutInterceptors.post('/api/no-auth/login/authenticate', { phoneNumber, code });
  return AuthenticateResponse.parse(response.data);
}
export async function isLoggedIn(): Promise<boolean> {
  const response = await clientWithoutInterceptors.get('/api/partial-auth/logged-in/', {
    validateStatus: status => status === 200 || status === 403,
  });
  return response.status === 200;
}
export async function updateChallengesProduct(): Promise<unknown> {
  const response = await client.put('/api/partial-auth/enable-challenges');
  return response.data;
}
export async function getActiveMember(): Promise<unknown> {
  const response = await client.get('/api/partial-auth/members/active-member');
  return response.data;
}
